module.exports = __webpack_public_path__ + "img/703.4b7fbb6c.jpg";